import React from 'react'
import { X, HelpCircle, AlertTriangle } from 'lucide-react'
import './styles.scss'

export default function ConfirmationModal({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = "Confirm Action", 
  message = "Are you sure you want to proceed with this action?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  isProcessing = false,
  type = "info" // 'info', 'warning', 'danger'
}) {
  if (!isOpen) return null

  // Determine styles based on type
  let icon = <HelpCircle size={24} color="#3b82f6" />
  let confirmBtnBg = '#3b82f6'
  
  if (type === 'warning') {
    icon = <AlertTriangle size={24} color="#f59e0b" />
    confirmBtnBg = '#f59e0b'
  } else if (type === 'danger') {
    icon = <AlertTriangle size={24} color="#dc2626" />
    confirmBtnBg = '#ef4444' // red-500
  }

  return (
    <div className="modal-overlay confirmation-modal">
      <div className="modal-content glass-panel">
        <div className="modal-header">
          <div className="header-title-container">
            <div className="icon-container" style={{ backgroundColor: `${confirmBtnBg}15` }}>
              {icon}
            </div>
            <h2>{title}</h2>
          </div>
          <button className="close-btn" onClick={onClose} disabled={isProcessing}>
            <X size={20} />
          </button>
        </div>
        
        <div className="modal-body">
          <p>{message}</p>
        </div>
        
        <div className="modal-footer">
          <button 
            className="btn-cancel" 
            onClick={onClose} 
            disabled={isProcessing}
          >
            {cancelText}
          </button>
          <button 
            className="btn-confirm" 
            onClick={onConfirm} 
            disabled={isProcessing}
            style={{ backgroundColor: confirmBtnBg }}
          >
            {isProcessing ? 'Processing...' : confirmText}
          </button>
        </div>
      </div>
    </div>
  )
}
